import { IContent } from '@/interfaces/lesson';
import styled, { StyledProp } from '@/styled';

const Embed = (props: IContent & StyledProp) => {
  const createElementsToEmbeded = () => {
    const div = document.createElement('div');
    div.innerHTML = props.content;
    const elements = div.getElementsByTagName('link');
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    return div.innerHTML;
  };

  return (
    <div
      className={props.className}
      id='lesson-type-text'
      dangerouslySetInnerHTML={{ __html: createElementsToEmbeded() }}
    />
  );
};

export default styled(Embed)`
  iframe,
  object,
  embed {
    width: auto;
    height: 100%;
    min-width: 100%;
    min-height: 500px;
    display: block;
  }

  p {
    word-break: break-word;
    hyphens: auto;
  }

  * {
    color: ${({ theme }) => theme.colorText};
  }

  @media (min-aspect-ratio: 16/9) {
    & > iframe,
    object,
    embed {
      width: 100%;
    }
  }

  @media (max-aspect-ratio: 16/9) {
    & > iframe,
    object,
    embed {
      width: auto;
    }
  }
`;
